import axios from 'axios';
import { API_URL } from '../config/api';

const trackActivity = async (eventType, entityId = null, metadata = {}) => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    await axios.post(`${API_URL}/activity/track`, {
      eventType,
      entityId,
      platform: 'WEB',
      metadata
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  } catch (error) {
    // Silently fail for activity tracking to avoid disrupting user experience
    console.warn('Activity tracking failed:', error.message);
  }
};

const activityService = {
  trackActivity,
  
  // Helper methods for common events
  trackTabActive: () => trackActivity('TAB_ACTIVE'),
  trackTabInactive: () => trackActivity('TAB_INACTIVE'),
  trackViewChanged: (viewName, entityId = null) => trackActivity('VIEW_CHANGED', entityId, { viewName }),
  trackProfileUpdated: () => trackActivity('PROFILE_UPDATED'),
  trackLogout: () => trackActivity('USER_LOGOUT')
};

export default activityService;
